/**
 * Display Value Converters
 * 
 * Convert database rating scales to normalized display values.
 * Database stores 1-100 for most metrics, but we display:
 * - 1-5 for intensity metrics (kinkiness, risk, skill)
 * - 1-10 with decimals for quality metrics (realism, ethics, rarity, acceptability)
 */

// Convert 1-100 database value → 1-5 display scale
export const to5Scale = (value) => {
    if (value == null || value === '') return '-';
    const num = Math.ceil(Number(value) / 20);
    return Math.min(5, Math.max(1, num));
};

// Convert 1-100 database value → 1-10 display with decimal
export const to10Scale = (value) => {
    if (value == null || value === '') return '-';
    return (Number(value) / 10).toFixed(1);
};

// Convert sex action skillLevel text → 1-5 number for display
export const skillToNumber = (skill) => {
    const map = { 'beginner': 1, 'intermediate': 3, 'advanced': 5 };
    return map[skill?.toLowerCase()] || 2;
};

// Render 1-5 scale as filled circles in React
export const render5Scale = (value) => {
    if (value === '-') {
        return <span className="text-gray-600">-</span>;
    }
    const filled = '●'.repeat(value);
    const empty = '○'.repeat(5 - value);
    return (
        <span className="font-mono text-sm">
            <span className="text-wine-500">{filled}</span>
            <span className="text-gray-700">{empty}</span>
        </span>
    );
};
